//Module for DBL concept-map component
angular.module('concept-map', []);
